<template>
  <div class="main-content">
    <Header />
    <div class="side-nav">
      <Sidebar :item="item" :hr="hr" />
    </div>
    <div class="content">
      <div class="leave">
        <div class="leave__header">
          <div class="leave__header--text">Leave Management</div>
        </div>
        <div class="leave__nav">
          <div class="leave__nav--list">
            <div
              @click="openSetup"
              v-bind:style="[
                setup
                  ? { borderBottom: '5px solid #5099de' }
                  : { borderBottom: '5px solid transparent' },
              ]"
            >
              Leave Type Setup
            </div>
            <div
              @click="openAssign"
              v-bind:style="[
                assign
                  ? { borderBottom: '5px solid #5099de' }
                  : { borderBottom: '5px solid transparent' },
              ]"
            >
              Assign leave to Emloyees
            </div>
            <div
              @click="openRequest"
              v-bind:style="[
                request
                  ? { borderBottom: '5px solid #5099de' }
                  : { borderBottom: '5px solid transparent' },
              ]"
            >
              Leave Requests
            </div>
          </div>
        </div>
        <div class="leave__body" v-if="setup">
          <LeaveSetup />
        </div>
        <div class="leave__body" v-if="assign">
          <LeaveAssign />
        </div>
        <div class="leave__body" v-if="request">
          <LeaveRequest />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../partials/header";
import Sidebar from "../../partials/sidebar";
import LeaveRequest from "./leaveRequest";
import LeaveSetup from "./leaveSetup";
import LeaveAssign from "./leaveAssign";

export default {
  name: "Leave",

  components: {
    Header,
    Sidebar,
    LeaveRequest,
    LeaveSetup,
    LeaveAssign,
  },

  data() {
    return {
      item: "leave",
      hr: "hr",
      request: false,
      setup: true,
      assign: false,
    };
  },
  metaInfo: {
    title: ' Core HR Solutions - Centralized Human Resources Management',
    meta: [
      { name: 'description', content: 'Simplify your HR processes with HR Desk\'s Core HR solutions. Centralize employee data, automate administrative tasks, and improve HR efficiency.' },
      { property: 'og:title', content: 'Core HR Solutions - Centralized Human Resources Management' },
      { property: 'og:description', content: 'Simplify your HR processes with HR Desk\'s Core HR solutions. Centralize employee data, automate administrative tasks, and improve HR efficiency.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://app.hrdesk.africa/promotion' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: ' Core HR Solutions - Centralized Human Resources Management' },
      { name: 'twitter:description', content: 'Simplify your HR processes with HR Desk\'s Core HR solutions. Centralize employee data, automate administrative tasks, and improve HR efficiency.' },
      { name: 'twitter:image:alt', content: ' core HR, HR solutions, employee data management, HR automation, HR efficiency' },
    ]
  },
  methods: {
    openRequest() {
      this.request = true;
      this.setup = false;
      this.assign = false;
    },
    openSetup() {
      this.request = false;
      this.setup = true;
      this.assign = false;
    },
    openAssign() {
      this.request = false;
      this.setup = false;
      this.assign = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.main-content {
  display: flex;
  max-width: 2000px;
  margin: 0 auto;

  .side-nav {
    width: 10rem;
    position: fixed;
    top: 2rem;
    left: 0;
    bottom: 0;
    background-color: #fff;
    margin-top: 4rem;

    ul {
      list-style: none;
      padding: 0;

      li {
        margin-bottom: 10px;
        cursor: pointer;
      }
    }

    @media (max-width: 768px) {
      display: none;
    }
  }

  .content {
    margin-top: 2rem;
    background: #fbfafa;
    margin-left: 200px;
    height: 100vh;

    @media (max-width: 768px) {
      margin-left: 0;
      padding: 1rem;
    }
  }

  @media (max-width: 768px) {
    .main-content {
      flex-direction: column;
      padding: 0;
    }
  }
}
.leave {
  padding-top: 56px;
  padding-left: 3.125vw;
  padding-right: 3.125vw;

  .leave__header {
    overflow: hidden;
    padding-bottom: 5px;

    > .leave__header--text {
      width: 500px;
      float: left;
      font-size: 30px;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.18;
      letter-spacing: normal;
      text-align: left;
      color: #000000;
      margin: 0;
    }
  }

  > .leave__nav {
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    align-content: center;

    > .leave__nav--list {
      width: calc(100% - 10px);
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: flex-start;
      align-content: center;
      @media (max-width: 768px) {
        justify-content: center;
      }

      > div {
        width: 200px;
        padding: 15px 0;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.25;
        letter-spacing: normal;
        text-align: center;
        color: #707070;
        border-bottom: 5px solid #5099de;
        cursor: pointer;
        @media (max-width: 768px) {
          font-size: 0.8rem;
          // width: 100px;
        }
      }
    }

    > .leave__nav--btn {
      width: 100px;
      background-color: #5099de;
      border-radius: 5px;
      padding: 10px 0;
      text-align: center;
      color: #fff;
      font-size: 14px;
      cursor: pointer;
    }
  }
}
</style>
